import { TableProps } from "antd";
import { useParams, useSearchParams } from "react-router-dom";
import TitleBar from "../../../../components/common/TitleBar";
import CustomTable from "../../../../components/ui/CustomTable";
import { AllKPIParams } from "../../../../features/organization/contractual/KPISetup/kpiSetup.type";
import { useGetAllKPIQuery } from "../../../../features/organization/contractual/KPISetup/kpiSetupApi";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import {
  addCommaInNumber,
  countParPageSerialNumber,
} from "../../../../utils/number";
import { valueOrNa } from "../../../../utils/string";
import { addKeyInArray } from "../../../../utils/utils";

export default function KPIPerformanceDetails() {
  const { kpiId } = useParams();
  const { page, limit, filter, keyword, handleLimit, handlePagination } =
    useTable<AllKPIParams>();

  const [searchParams] = useSearchParams();
  const date = searchParams.get("date");

  // ------ Queries ------
  const { data, isLoading, isFetching } = useGetAllKPIQuery(
    {
      args: { params: { ...filter, search: keyword } },
      kpiGroupId: kpiId as string,
    },
    { skip: !kpiId }
  );

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "KPI",
      dataIndex: "kpi_name",
      render: (val) => valueOrNa(val),
    },
    {
      align: "center",
      title: "Weightage",
      dataIndex: "weightage_percentage",
      render: (val) => <span>{`${addCommaInNumber(val || 0)}%`}</span>,
    },
    {
      align: "center",
      title: "Threshold",
      dataIndex: "threshold_percentage",
      render: (val) => <span>{`${addCommaInNumber(val || 0)} %`}</span>,
    },
    // {
    //   align: "center",
    //   title: "Achieved",
    //   dataIndex: "achieved",
    //   render: (val) => <span>{`${addCommaInNumber(val || 0)}%`}</span>,
    // },
  ];

  return (
    <>
      <SidebarLayout title="My Projects">
        <TitleBar backLink={-1 as unknown as string} title={`${date}`} />
        <CustomTable
          loading={isLoading || isFetching}
          limit={limit}
          page={page}
          columns={columns}
          total={data?.data?.total || 0}
          dataSource={addKeyInArray(data?.data?.kpis || [])}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={<></>}
        />
      </SidebarLayout>
    </>
  );
}
